import React, { FC, useMemo } from "react";
import { useSelector } from "react-redux";

import { MapControlContainer } from "../../styled";
import { ChatControlButton } from "./ChatControlButton";

import { useUser } from "../../../../hooks/user/useUser";
import { getAppConfig } from "../../../../ducks/appConfig";

const ALLOWED_ROLES = ["__superuser", "ai_sense"];

export const ChatControl: FC = () => {
  const user = useUser();
  const appConfig = useSelector(getAppConfig);
  const senseEnabled = useMemo(() => {
    return appConfig?.settings?.sense?.enabled && !!appConfig?.settings?.sense?.url;
  }, [appConfig?.settings?.sense]);

  if (!senseEnabled || (senseEnabled && !user?.roles?.some(item => ALLOWED_ROLES.includes(item)))) {
    return null;
  }

  return (
    <MapControlContainer width="2.25rem" minWidth="2.25rem" withPadding>
      <ChatControlButton />
    </MapControlContainer>
  );
};
